<template>
  <div>
    <van-nav-bar title="登录" />
    <h2 class="block__title">用户登录</h2>
    <van-form @submit="onSubmit">
  <van-field
    v-model="username"
    name="手机号"
    label="手机号"
    placeholder="手机号"
    :rules="[{ required: true, message: '请填写手机号' }]"
  />
  <div v-if="usePass">
    <van-field
    v-model="password"
    type="password"
    name="密码"
    label="密码"
    placeholder="密码"
  />
  </div>
  <div v-if="!usePass">
    <van-field
      v-model="sms"
      center
      clearable
      label="短信验证码"
      placeholder="请输入短信验证码"
    >
      <template #button>
        <van-button size="small" :disabled="usePass" type="primary" v-if="!smsdisabled && !usePass" @click="getsmscap()" native-type="button" >发送验证码</van-button>
        <van-button size="small" type="primary" disabled v-else native-type="button" >剩余{{second}}秒</van-button>
      </template>
    </van-field>
  </div>
 
  <div style="margin: 16px;">
    <van-checkbox v-model="usePass">使用密码登录</van-checkbox>
    <br/>
    <van-button round block type="info" native-type="submit">提交</van-button>
  </div>
</van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getsmscode } from '@/api/login.js'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      sms: '',
      loading: false,
      smsdisabled: false,
      second: 60,
      usePass: false
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('Login', { username: this.username, password: this.password, sms: this.sms }).then(() => {
          this.loading = false
          this.$router.push({ path: '/' })
        }).catch((e) => {
          Toast.fail(e)
          this.loading = false
      })
    },
    getsmscap() {
      if(!this.username) {
        Toast.fail("请填写手机号");
        return;
      }
      const _this = this
      getsmscode(this.username).then(() => {
        Toast.success("验证码已发送");
        _this.second = 60
        _this.smsdisabled = true
        let timer = () => {
          _this.second -= 1
          if(_this.second >= 0) {
            setTimeout(timer, 1000)
          } else {
            _this.smsdisabled = false
          }
        }
        setTimeout(timer, 1000)
      }).catch((e) => {
          Toast.fail(e)
          this.loading = false
      })
      return false
    }
  }
}
</script>
